module.exports = __webpack_public_path__ + "d6ffd6b60f0931149542cdfb553b2c66.jpg";